/**
 * 默认图片
 * */
export var defaultImg = {
	default: '//image1.51tiangou.com/tgou2/img2/fitting/defaultFittingListPic.png'
	, logoImageUrl: '//image1.51tiangou.com/tgou2/img2/fitting/defaultPic.jpg'
	, hotTopic: '//image1.51tiangou.com/tgou2/img2/fittingShow/topic_default.jpg'
	, topicIndexBg: '//image1.51tiangou.com/tgou2/img2/fitting/fittingTopicBg.jpg'
	, topicIndexLogo: '//image1.51tiangou.com/tgou2/img2/fitting/topicPhoto.jpg!s'
	, albumImage: '//image1.51tiangou.com/tgou2/img2/main/android_download_logo2.png'
};

export function errImg(item, attr='imageUrl', img){
	item[attr] = defaultImg[img || attr] || defaultImg.default;
}
